import axios from '@/plugins/axios';

export default {
  getContracts(params, config = {}) {
    return axios.get('/v1/rental-contracts', { params, ...config });
  },
  exportContractsExcel(params = {}) {
    return axios.get('/v1/rental-contracts/export/excel', {
      params,
      responseType: 'blob',
    });
  },
  exportContractsPdf(params = {}) {
    return axios.get('/v1/rental-contracts/export/pdf', {
      params,
      responseType: 'blob',
    });
  },
  getContract(contractId, config = {}) {
    return axios.get(`/v1/rental-contracts/${contractId}`, config);
  },
  getContractEquipments(contractId, params = {}) {
    return axios.get(`/v1/rental-contracts/${contractId}/equipments`, { params });
  },
  getAvailableEquipments(config = {}) {
    return axios.get('/v1/rental-contracts/equipments', config);
  },
  createContract(payload, config = {}) {
    return axios.post('/v1/rental-contracts', payload, config);
  },
  updateContract(contractId, payload) {
    return axios.put(`/v1/rental-contracts/${contractId}`, payload);
  },
  deleteContract(contractId) {
    return axios.delete(`/v1/rental-contracts/${contractId}`);
  },
  getContractHistory(contractId, params = {}) {
    return axios.get(`/v1/rental-contracts/${contractId}/history`, { params });
  },
  getContractDocuments(contractId, params = {}) {
    return axios.get(`/v1/rental-contracts/${contractId}/documents`, { params });
  },
  createContractDocument(contractId, payload) {
    return axios.post(`/v1/rental-contracts/${contractId}/documents`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteContractDocument(contractId, documentId) {
    return axios.delete(`/v1/rental-contracts/${contractId}/documents/${documentId}`);
  },
  getContractChecklists(contractId) {
    return axios.get(`/v1/rental-contracts/${contractId}/checklists`);
  },
  createContractChecklist(contractId, payload) {
    return axios.post(`/v1/rental-contracts/${contractId}/checklists`, payload);
  },
  detachContractChecklist(checklistId) {
    return axios.delete(`/v1/rental-checklists/${checklistId}/association`);
  },
  getRentalChecklist(checklistId) {
    return axios.get(`/v1/rental-checklists/${checklistId}`);
  },
  getCertificateLayout(checklistId, checklistIds = []) {
    return axios.get(`/v1/rental-checklists/${checklistId}/certificate-layout`, {
      params: { checklist_ids: checklistIds },
    });
  },
  saveCertificateLayout(checklistId, layout, checklistIds = []) {
    return axios.put(`/v1/rental-checklists/${checklistId}/certificate-layout`, {
      layout,
      checklist_ids: checklistIds,
    });
  },
  createRentalChecklistAnswer(checklistId, questionId) {
    return axios.post(`/v1/rental-checklists/${checklistId}/answers`, {
      rental_checklist_question_id: questionId,
    });
  },
  updateRentalChecklistAnswerComment(answerId, comment) {
    return axios.patch(`/v1/rental-checklist-answers/${answerId}/comment`, { comment });
  },
  updateRentalChecklistAnswerSignature(answerId, payload) {
    return axios.patch(`/v1/rental-checklist-answers/${answerId}/signature`, payload);
  },
  updateRentalChecklistAnswerStatus(answerId, answer) {
    return axios.patch(`/v1/rental-checklist-answers/${answerId}/status`, { answer });
  },
  updateRentalChecklist(checklistId, payload) {
    return axios.post(`/v1/rental-checklists/${checklistId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  finalizeRentalChecklist(checklistId) {
    return axios.post(`/v1/rental-checklists/${checklistId}/finalize`);
  },
  downloadDeliveryCertificate(checklistId, payload = null) {
    return axios.post(`/v1/rental-checklists/${checklistId}/delivery-certificate`, payload || {}, {
      ...(payload ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}),
      responseType: 'blob',
    });
  },
  downloadReceptionCertificate(checklistId, payload = null) {
    return axios.post(`/v1/rental-checklists/${checklistId}/reception-certificate`, payload || {}, {
      ...(payload ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}),
      responseType: 'blob',
    });
  },
  deleteRentalChecklistPhoto(photoId) {
    return axios.delete(`/v1/rental-checklist-photos/${photoId}`);
  },
  getChecklistTemplates(params) {
    return axios.get('/v1/rental-checklist-templates', { params });
  },
  getChecklistTemplate(templateId) {
    return axios.get(`/v1/rental-checklist-templates/${templateId}`);
  },
  getChecklistTemplateHistory(templateId) {
    return axios.get(`/v1/rental-checklist-templates/${templateId}/history`);
  },
  createChecklistTemplate(payload) {
    return axios.post('/v1/rental-checklist-templates', payload);
  },
  updateChecklistTemplate(templateId, payload) {
    return axios.put(`/v1/rental-checklist-templates/${templateId}`, payload);
  },
  getChecklistQuestions(params) {
    return axios.get('/v1/rental-checklist-questions', { params });
  },
  createChecklistQuestion(payload) {
    return axios.post('/v1/rental-checklist-questions', payload);
  },
  updateChecklistQuestion(questionId, payload) {
    return axios.put(`/v1/rental-checklist-questions/${questionId}`, payload);
  },
  deleteChecklistQuestion(questionId) {
    return axios.delete(`/v1/rental-checklist-questions/${questionId}`);
  },
};
